import { Alert, Collapse, SxProps } from '@mui/material';

interface PriceUnsetAlertProps {
	isVisible: boolean;
	severity?: 'error' | 'warning' | 'info' | 'success';
	isSelected?: boolean;
	isGrayIfNotSelected?: boolean;
	isCentered?: boolean;
	isUppercase?: boolean;
	sx?: SxProps;
	children: React.ReactNode;
}

function PriceUnsetAlert({
	isVisible,
	severity = 'info',
	isSelected = true,
	isGrayIfNotSelected = false,
	isCentered = false,
	isUppercase = false,
	sx = {},
	children
}: PriceUnsetAlertProps) {
	return (
		<Collapse in={isVisible}>
			<Alert 
				severity={severity}
				sx={{
					justifyContent: isCentered ? 'center' : undefined,
					backgroundColor: isGrayIfNotSelected && !isSelected ? 'rgba(0, 0, 0, 0.05)' : undefined, // Light gray overlay when not selected
					color: isGrayIfNotSelected && !isSelected ? 'rgba(0, 0, 0, 0.3)' : undefined, // Dim text color when not selected
					textTransform: isUppercase ? 'uppercase' : undefined,
					'& .MuiAlert-icon': { // Optionally dim the icon as well
						color: isGrayIfNotSelected && !isSelected ? 'rgba(0, 0, 0, 0.3)' : undefined,
					},
					...sx
				}}
			>
				{children}
			</Alert>
		</Collapse>
	);
}

export default PriceUnsetAlert;